import * as _ from 'lodash'
import {IBusinessObject} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {WB_JobRow} from "../PA.Core/PAdbSchemaRows";
import {IwbJob} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Job, esWB_Job_Run
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class JobBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_Job: WB_JobRow;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Job'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_Job = null;
    }

    get WB_Job(): WB_JobRow
    {
        return this.drWB_Job;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        var self = this;
        this.LoadProgressProvider.start("Creating Job");
        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, error) => {

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Job.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_Job)
              .then((newJobRow: WB_JobRow)=> {
                  newJobRow.setDefaults()
                  self.drWB_Job = newJobRow;
                  //add this to all the BOs
                  self.dbContext.add(esWB_Job, newJobRow)

                  self.Identity.setAll(self.WB_Job.cif.WB_JOB_ID, self.WB_Job.cif.JOB_ID, self.WB_Job.cif.JOB_NAME);
                  self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                  self.Identity.listenToRecordUpdates(self.WB_Job, 'WB_JOB_ID','JOB_ID','JOB_NAME')

                  self.LoadProgressProvider.finish();
                  self._bIsLoaded = true;
                  self._OnLoadComplete = null;
                  resolve(self);

              })
              .catch((err) => {
                self.LoadProgressProvider.exception(err)
                error(err)
              })

        });

        return this._OnLoadComplete;
    }


    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;
        if(!this.bIsLoaded)
            this.Identity.setAll( anId, anId,'Loading Job (' + anId + ')')

        this._OnLoadComplete = new Promise<IBusinessObject>( (resolve, reject) => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if(self.bIsLoaded) {
                var sError = "Job already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new Job.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                reject(sError);
                return;
            }

            this.dbContext.find(esWB_Job,  anId)
                .then((aJobRow) => {

                    if(_.isEmpty(aJobRow))
                    {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_Job = aJobRow;
                    self.Identity.setAll(self.WB_Job.cif.WB_JOB_ID, self.WB_Job.cif.JOB_ID, self.WB_Job.cif.JOB_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_Job, 'WB_JOB_ID','JOB_ID','JOB_NAME')

                    // TODO, add in additional child relationships.
                    return (self.drWB_Job.loadRelations([esWB_Job_Run],
                        self.LoadOptions));
                })
                .then((aJobRow:any) => {
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch(function(err:any){
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    reject(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_Job.cif.JOB_NAME + "(" + self.WB_Job.cif.JOB_ID + ")");
        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if(self.dbContext == null) {
                var sError = "Unable to determine dbContext for to Validate Job.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    private SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbJob = <IwbJob>self.drWB_Job;
        this.SaveProgressProvider.start("Saving " + wbJob.JOB_NAME + "(" + wbJob.JOB_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save Meta.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

    var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
    if (bBatch) {
        saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
    } else {
    saveFunction = self.dbContext.Save.bind(self.dbContext)
}

saveFunction(esWB_Job, self.drWB_Job,{})
    .then((ignored) => {
        if (bBatch) {
            self.dbContext.addBatchCompleteListener(()=> {
                self._bIsSaved = true;
            })
        } else {
            self._bIsSaved = true;
        }
        self.SaveProgressProvider.finish();
        resolve(self);
    })
    .catch((err) => {
        self.SaveProgressProvider.exception(err);
        resolve(self)
    })
});
}

get  bIsSaved(): boolean {
    return this._bIsSaved;
}

    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbJob = <IwbJob>self.drWB_Job;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbJob.JOB_NAME + "(" + wbJob.WB_JOB_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the Meta

            // 2. If Valid, mark all the records for deletion.
            self.drWB_Job.markDeleted()

            if(bSaveNow) {
                self.SaveUsing(false)
                  .then((ignore) => {
                      self._bIsDeleted = true;
                      self.DeleteProgressProvider.finish();
                      resolve(self);

                  })
                  .catch((err) => {
                      this.DeleteProgressProvider.exception(err)
                      resolve(self)
                  })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }



    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    //</editor-fold>

};
PAEnvironment.registerBusinessObjectClass( JobBO, "JobBO" , "Job")